import { createGuid } from "cesium";
import { Site } from "./site";
export class FlatGroundStructure {
    connectionNodes;
    flatGround;
    constructor(flatGround) {
        this.connectionNodes = [];
        this.flatGround = flatGround;
    }
    getConnectionInfo(point) {
        const site = Site.getInstance();
        const parentFlatground = site.getFlatGround(point.info.structureInfo.id); // point.info.structureInfo.id can be anything
        if (parentFlatground) {
            const info = parentFlatground.getClosestPointInfoOnPath(point.localPosition);
            const totalLength = parentFlatground.getPerimeter();
            const proportionInTotal = info.distanceFromStart / totalLength;
            return { proportionInTotal };
        }
    }
    getConnectionNodes() {
        const site = Site.getInstance();
        const connectionNodes = [];
        for (let i = 0; i < this.flatGround._pointsForFlatGround.length; ++i) {
            const pointstructureInfo = this.flatGround._pointsForFlatGround[i]?.info?.structureInfo;
            if (pointstructureInfo && pointstructureInfo.id !== this.flatGround.id) {
                const parentStructure = site.structureManager.getStructure(pointstructureInfo.id);
                const { proportionInTotal } = parentStructure.getConnectionInfo(this.flatGround._pointsForFlatGround[i]);
                const connectionNode = {
                    id: createGuid(),
                    from: {
                        id: pointstructureInfo.id,
                        proportionInTotal,
                    },
                    to: {
                        id: this.flatGround.id,
                        controlPointIndex: i,
                    },
                };
                connectionNodes.push(connectionNode);
            }
        }
        return connectionNodes;
    }
    // private updateNodeForProportionInTotal(
    // 	node: IConnectionNode,
    // 	segmentId: number,
    // ) {
    // 	let distanceToSegment = 0;
    // 	const points = this.flatGround.points;
    // 	for (let i = 0; i < segmentId; ++i) {
    // 		distanceToSegment += Cartesian3.distance(points[i], points[i + 1]);
    // 	}
    // 	const segmentLength = Cartesian3.distance(
    // 		node.from.bounds[0],
    // 		node.from.bounds[1],
    // 	);
    // 	const distanceInthisSegment = node.from.proportionInBounds * segmentLength;
    // 	node.from.proportionInTotal =
    // 		(distanceInthisSegment + distanceToSegment) /
    // 		this.flatGround.getPerimeter();
    // }
    updateConnectionOnAddUpdatePoint() {
        const site = Site.getInstance();
        const nodes = site.structureManager.getImmediateChildrenNodes(this.flatGround.id);
        for (const node of nodes) {
            // let segmentId = undefined;
            // const points = this.flatGround.points;
            // for (let i = 0; i < points.length; ++i) {
            // 	const nextIndex = (i + 1) % points.length;
            // 	if (
            // 		Cartesian3.equals(points[i], node.from.bounds[0]) &&
            // 		Cartesian3.equals(points[nextIndex], node.from.bounds[1])
            // 	) {
            // 		segmentId = i;
            // 		break;
            // 	}
            // }
            // if (segmentId !== undefined) {
            // 	this.updateNodeForProportionInTotal(node, segmentId);
            // } else {
            // 	this.updateNodeForProportionInBounds(node);
            // }
        }
    }
    updateConnectionOnDeletePoint() {
        const site = Site.getInstance();
        const nodes = site.structureManager.getImmediateChildrenNodes(this.flatGround.id);
        for (const node of nodes) {
            //check if segment exists;
            // let segmentId = undefined;
            // const points = this.flatGround.points;
            // for (let i = 0; i < points.length; ++i) {
            // 	const nextIndex = (i + 1) % points.length;
            // 	if (
            // 		Cartesian3.equals(points[i], node.from.bounds[0]) &&
            // 		Cartesian3.equals(points[nextIndex], node.from.bounds[1])
            // 	) {
            // 		segmentId = i;
            // 		break;
            // 	}
            // }
            // if (segmentId !== undefined) {
            // 	this.updateNodeForProportionInTotal(node, segmentId);
            // } else {
            // 	//check if first point or last point is deleted
            // 	this.updateNodeForProportionInBounds(node);
            // }
        }
        return [];
    }
    async updateGeometry() {
        await this.flatGround.computeGeometry();
    }
    getPointInfoAtProportionIntotal(proportion) {
        return this.flatGround.getPointInfoAtDistance(this.flatGround.getPerimeter() * proportion);
    }
}
//# sourceMappingURL=flat-ground-structure.js.map